export default "__VITE_PUBLIC_ASSET__b855a4a5__"